import React, { useState } from 'react';
import './PermitsSelector.css';

const PermitsSelector = ({ permissions, setPermissions, disabled, error }) => {
  const [isOpen, setIsOpen] = useState(false);

  const permissionsSelected = () => {
    let permits = 0
    permissions.map(permit => {
      if(permit.value && permit.label !== 'selected-all') permits++
    })
    return permits
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handlePermitToggle = (permit) => {
    if(permit.label === 'selected-all') {
      const newValue = !permit.value;
      setPermissions((prev) => prev.map(p => ({ ...p, value: newValue })));
      return;
    }
    if(permit.value) {
      setPermissions((prev) => prev.map(p => p.label === permit.label ? { ...p, value: false } : p));
    } else {
      setPermissions((prev) => prev.map(p => p.label === permit.label ? { ...p, value: true } : p));
    }
  };

  return (
    <div className="permits-selector">
      <div className="input-container">
        <div className="permits-input" onClick={toggleDropdown}>
          <input
            type="text"
            value={permissionsSelected() > 0 ? `${permissionsSelected()} permissions selected` : 'Selected options'}
            readOnly
            className={`custom-input ${error ? 'input-error' : ''}`}
          />
          <button className={`view-more-btn ${isOpen ? 'open' : ''}`}>
            <span className="arrow-icon">›</span>
          </button>
        </div>
        {error && <span className="error-message">{error}</span>}
        {isOpen && (
          <div className="permits-dropdown">
            <div className="permits-list">
              {permissions.map((permit) => (
                <label key={permit.label} className="permit-option">
                  <input
                    disabled={disabled}
                    type="checkbox"
                    checked={permit.value}
                    onChange={() => handlePermitToggle(permit)}
                  />
                  <span>{permit.title}</span>
                </label>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PermitsSelector;
